import { produce } from "immer";
import {
  ADD_TEAM,
  ADD_TEAM_FAILURE,
  ADD_TEAM_SUCCESS,
  //
  DELETE_TEAM,
  DELETE_TEAM_FAILURE,
  DELETE_TEAM_SUCCESS,
  //
  EDIT_TEAM,
  EDIT_TEAM_FAILURE,
  EDIT_TEAM_SUCCESS,
  //
  FETCH_TEAMS,
  FETCH_TEAMS_FAILURE,
  FETCH_TEAMS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_TEAM_ADD_MODAL,
  //
  SEARCH_TEAMS,
  SEARCH_TEAMS_SUCCESS,
  SEARCH_TEAMS_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingTeams: false,
  team: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentTeam: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  //
  teamAddModal: {
    open: false,
    isEditing: false,
  },
  //
  isSearchingTeams: false,
  searchTeamList: [],
};

const TeamReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_TEAMS:
        draft.isFetchingTeams = true;
        draft.team = [];
        break;
      case FETCH_TEAMS_SUCCESS:
        draft.isFetchingTeams = false;
        draft.team = action.payload;
        break;
      case FETCH_TEAMS_FAILURE:
        draft.isFetchingTeams = false;
        draft.team = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentTeam = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentTeam = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentTeam = {};
        break;
      // Add
      case ADD_TEAM:
        draft.isSubmitting = true;
        break;
      case ADD_TEAM_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_TEAM_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_TEAM:
        draft.isSubmitting = true;
        break;
      case EDIT_TEAM_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_TEAM_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_TEAM:
        draft.isDeleting = true;
        break;
      case DELETE_TEAM_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_TEAM_FAILURE:
        draft.isDeleting = false;
        break;
      //
      case TOGGLE_TEAM_ADD_MODAL:
        draft.teamAddModal = action.payload;
        break;

      case SEARCH_TEAMS:
        draft.isSearchingTeams = true;
        draft.searchTeamList = [];
        break;
      case SEARCH_TEAMS_SUCCESS:
        draft.isSearchingTeams = false;
        draft.searchTeamList = action.payload;
        break;
      case SEARCH_TEAMS_FAILURE:
        draft.isSearchingTeams = false;
        draft.searchTeamList = [];
        break;

      default:
        return state;
    }
  });

export default TeamReducer;
